import Vue from "vue";
import BookingEvent from './BookEvent.vue';

Vue.component('single-company', {
  components: {
    BookingEvent
  },

  data: () => {
    return {
      locationsExpanded: false,
      contactExpanded: false,
      themesExpanded: false,
    }
  },

  methods: {
    toggleLocations() {
      this.locationsExpanded = !this.locationsExpanded;
    },

    toggleContact() {
      this.contactExpanded = !this.contactExpanded;
    },

    toggleThemes() {
      this.themesExpanded = !this.themesExpanded;
    },
  }
});
